var _defs, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModuleReporting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 3333.3333,
    height: 3333.3333,
    viewBox: "0 0 3333.3333 3333.3333",
    sodipodiDocname: "reporting_module.ai",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,2500 H 2500 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "reporting_module",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,3333.3333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(394.157,1509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-468.338 379.663,-848 848,-848 468.337,0 848,379.662 848,848 0,468.338 -379.663,848 -848,848 C 379.663,848 0,468.338 0,0",
    style: {
      fill: "#fdbb3b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(394.157,1509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-468.338 379.663,-848 848,-848 468.337,0 848,379.662 848,848 0,468.338 -379.663,848 -848,848 C 379.663,848 0,468.338 0,0 Z",
    style: {
      fill: "none",
      stroke: "#fdbb3b",
      strokeWidth: 60,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 671.439,1916.879 H 1812.874 V 1165.922 H 671.439 Z",
    style: {
      fill: "#006b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(1815.8744,1931.8788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -1147.435 c -6.6,0 -12,-5.4 -12,-12 v -756.957 c 0,-6.6 5.4,-12 12,-12 H 0 c 6.6,0 12,5.4 12,12 V -12 C 12,-5.4 6.6,0 0,0 M -18,-750.957 H -1129.435 V -30 H -18 Z",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(1127.6709,983.6045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -6.341,0 -11.5,5.159 -11.5,11.5 v 173.778 c 0,6.341 5.159,11.5 11.5,11.5 h 228.973 c 6.34,0 11.5,-5.159 11.5,-11.5 V 11.5 c 0,-6.341 -5.16,-11.5 -11.5,-11.5 z",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(1356.6432,1180.8829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -228.972 c -6.6,0 -12,-5.4 -12,-12 v -173.778 c 0,-6.6 5.4,-12 12,-12 H 0 c 6.6,0 12,5.4 12,12 V -12 C 12,-5.4 6.6,0 0,0 m 0,-1 c 6.065,0 11,-4.935 11,-11 v -173.778 c 0,-6.066 -4.935,-11 -11,-11 h -228.972 c -6.066,0 -11,4.934 -11,11 V -12 c 0,6.065 4.934,11 11,11 z",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(903.8813,969.8057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -6.341,0 -11.5,5.159 -11.5,11.5 v 33.494 c 0,6.341 5.159,11.5 11.5,11.5 h 676.551 c 6.341,0 11.5,-5.159 11.5,-11.5 V 11.5 c 0,-6.341 -5.159,-11.5 -11.5,-11.5 z",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(1580.4326,1026.7997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -676.551 c -6.6,0 -12,-5.4 -12,-12 v -33.494 c 0,-6.6 5.4,-12 12,-12 H 0 c 6.6,0 12,5.4 12,12 V -12 C 12,-5.4 6.6,0 0,0 m 0,-1 c 6.065,0 11,-4.935 11,-11 v -33.494 c 0,-6.065 -4.935,-11 -11,-11 h -676.551 c -6.066,0 -11,4.935 -11,11 V -12 c 0,6.065 4.934,11 11,11 z",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(784.1288,1358.632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 145.351,130.748 305.738,84.81 579.733,293.301 718.401,137.816 890.135,320.503",
    style: {
      fill: "none",
      stroke: "#00405a",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path50"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleReporting);
export default __webpack_public_path__ + "static/media/module-reporting.d0fcf79cbd7f6c42109304ea89fece0c.svg";
export { ForwardRef as ReactComponent };